var map = {
	"./2024-mothers-day/au/tablet.jpg": 14838,
	"./2024-mothers-day/na/tablet.jpg": 54205,
	"./fathersday/tablet.jpg": 32438,
	"./generic/tablet.jpg": 96342,
	"./holiday/tablet.jpg": 88451,
	"./mothersday/au/tablet.jpg": 30774,
	"./mothersday/na/tablet.jpg": 53789,
	"./mothersday/tablet.jpg": 33111,
	"./valentines/tablet.jpg": 13854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23820;